import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoUser } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoUserStoreFactory } from './dto.user.store.factory';

@Injectable()
export class DtoUserEffects extends EntityStoreEffects<IDtoUser> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.user', actions$, DtoUserStoreFactory.instance, dataServiceAccessor);
    }

    loadUsersForWebFrontendAndMandator$: Observable<Action> = DtoUserStoreFactory.instance.getEffect('load.for.web')(this.actions$, this.dataServiceAccessor);

}
